import React, { useState } from "react";
import { Input } from "@lainco/react-toolbox";
import { formatAmount } from "../lib/misc";

export function InputNumber({ value, onChange, precision, ...props }) {
  const [isEditing, setIsEditing] = useState(false);

  return (
    <Input
      align="right"
      outline={true}
      value={isEditing ? value : formatAmount(value, { precision, showZero: true })}
      onFocus={() => setIsEditing(true)}
      onBlur={() => setIsEditing(false)}
      onChange={onChange}
      {...props}
    />
  );
}
